import React from 'react';
import PropTypes from 'prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';
import LogoIcon from '../../../../public/static/icons/logos/logo-white.svg';
import Link, { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import BlockFooter from '../../../02_molecules/BlockFooter';
import FormattedText from '../../../01_atoms/FormattedText';

import styles from './index.module.scss';

const BBHighlightedListWithIcons = ({
  heading,
  items,
  button = null,
  logoLink = null,
  behaviorSettings = null,
  buttonDescription = '',
  uuid = null,
}) => (
  <div
    className={`bb bb-highlighted-list-with-icons ${
      styles['bb-highlighted-list-with-icons']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      {logoLink && (
        <Link {...logoLink}>
          <a tabIndex="0">
            <LogoIcon
              alt="Concern Worldwide"
              className={styles['bb-highlighted-list-with-icons__logo']}
              aria-label="Concern Worldwide"
            />
          </a>
        </Link>
      )}
      <FormattedText
        tag="h3"
        className={styles['bb-highlighted-list-with-icons__heading']}
        text={heading}
      />
      <div className={styles['bb-highlighted-list-with-icons__items']}>
        {items.map((item) => (
          <div className={styles['bb-highlighted-list-with-icons__item']} key={item.title}>
            {item.icon && item.icon.url && (
              <img
                className={styles['bb-highlighted-list-with-icons__item_icon']}
                src={item.icon.url}
                alt={item.icon.alt}
                width={40}
                height={40}
                loading="lazy"
              />
            )}
            <div>
              <div className={styles['bb-highlighted-list-with-icons__item_title']}>
                {item.title}
              </div>
              <div className={styles['bb-highlighted-list-with-icons__item_description']}>
                {item.description}
              </div>
            </div>
          </div>
        ))}
      </div>
      {button && button.nextLink && (
        <div className={`${styles['bb-highlighted-list-with-icons__button']} d-xl-none`}>
          <BlockFooter button={button} buttonDescription={buttonDescription} variant="white" />
        </div>
      )}
    </div>
  </div>
);

BBHighlightedListWithIcons.propTypes = {
  uuid: PropTypes.string,
  heading: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    nextLink: PropTypes.shape(linkPropTypes).isRequired,
  }),
  buttonDescription: PropTypes.string,
  logoLink: PropTypes.shape(linkPropTypes).isRequired,
};

export default BBHighlightedListWithIcons;
